import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { VoyadoCrmService } from 'src/app/core/services/voyado-crm.service';
import { finalize } from 'rxjs/operators';
import { ContactMessage } from '../../../core/models/contact-message.model';
import { ContactMessages } from '../../../core/models/contact-messages.model';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { FocusDirective } from '../../../../sb-tools/typescript/directives/focus.directive';
import { LoaderComponent } from '../../../../sb-tools/typescript/components/loader/loader.component';
import { PagingComponent } from '../../../../sb-modules/Frontend-Table-Module/components/paging/paging.component';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-voyado-messages',
    templateUrl: './voyado-messages-modal.component.html',
    styleUrls: ['./voyado-messages-modal.component.scss'],
    imports: [InlineSVGComponent, FocusDirective, LoaderComponent, PagingComponent, DatePipe, TranslateModule],
})
export class VoyadoMessagesModalComponent implements OnInit, OnDestroy {
    activePage = 1;
    contactId: number;
    contactMessages: ContactMessage[];
    isLoading = false;
    totalItems: number;

    readonly pageSize: number = 25;
    private unsubscriber = new Subject<void>();

    constructor(
        public modalRef: BsModalRef,
        private voyadoCrmService: VoyadoCrmService,
    ) {}

    ngOnInit(): void {
        this.getContactMessages(this.activePage);
    }

    decline(): void {
        this.modalRef.hide();
    }

    getContactMessages(activePage: number): void {
        const skipItems = (activePage - 1) * this.pageSize;
        this.isLoading = true;
        this.voyadoCrmService
            .getContactMessages(this.contactId, this.pageSize, skipItems)
            .pipe(
                takeUntil(this.unsubscriber),
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe((contactMessages: ContactMessages) => {
                this.contactMessages = contactMessages.items;
                this.totalItems = contactMessages.totalCount;
            });
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
